"use strict";
module.exports = {
    'v1.customerSubUnit.setDeliveryRules': 'oms',
    'v1.customerSubUnit.writeCustomerSubUnit': 'oms',
    'v1.customerSubUnit.changeDeliveryDetails': 'oms',
    'v1.customerSubUnit.changeInvoiceDetails': 'oms',
    'v1.customerSubUnit.approveCustomerSubUnit': 'oms',
    'v1.customerSubUnit.blockCustomerSubUnit': 'oms',
    'v1.customerSubUnit.unblockCustomerSubUnit': 'oms',
    'v1.customerSubUnit.approveAlcoholLicense': 'oms',
    'v1.customerSubUnit.revokeAlcoholLicense': 'oms',
    'v1.customerSubUnit.setCustomerType': 'oms',
    'v1.customerSubUnit.requestNewInvoiceInformation': 'oms',
    'v1.customerSubUnit.writeContact': 'oms',
    'v1.customerSubUnit.writeContactAndInvite': 'oms',
    'v1.customerSubUnit.removeContact': 'oms',
    'v1.customerSubUnit.setExternalCustomerNumber': 'oms',
    'v1.customerSubUnit.markAsDuplicateOf': 'oms',
    'v1.customerSubUnit.ensureInvariants': 'oms',
    'v1.customerSubUnit.connectToQvanti': 'oms',
    'v1.customerSubUnit.disconnectFromQvanti': 'oms',
    'v1.customerSubUnit.upsert': 'oms',
    'v1.customerSubUnit.upsertWhenEmpty': 'oms',
    'v1.customerSubUnit.updateWhenEmpty': 'oms',
    'v1.customerSubUnit.update': 'oms',
    'v1.brand.writeBrand': 'oms',
    'v1.brand.activate': 'oms',
    'v1.brand.deactivate': 'oms',
    'v1.brand.upsert': 'oms',
    'v1.brand.upsertWhenEmpty': 'oms',
    'v1.brand.updateWhenEmpty': 'oms',
    'v1.brand.update': 'oms',
    'v1.supplier.setOwningSupplierOrganization': 'oms',
    'v1.supplier.suggestNewSupplier': 'oms',
    'v1.supplier.ensureOrders': 'oms',
    'v1.supplier.requestDemo': 'oms',
    'v1.supplier.writeSupplier': 'oms',
    'v1.supplier.disconnectFromExtend': 'oms',
    'v1.supplier.upsert': 'oms',
    'v1.supplier.upsertWhenEmpty': 'oms',
    'v1.supplier.updateWhenEmpty': 'oms',
    'v1.supplier.update': 'oms',
    'v1.article.setOwningSupplierOrganization': 'oms',
    'v1.article.handlePublications': 'oms',
    'v1.article.publishOnExacta': 'oms',
    'v1.article.deactivate': 'oms',
    'v1.article.activate': 'oms',
    'v1.article.markAsOutOfStock': 'oms',
    'v1.article.markAsInStock': 'oms',
    'v1.article.startCampaign': 'oms',
    'v1.article.endCampaign': 'oms',
    'v1.article.setSupplierArticleNumber': 'oms',
    'v1.article.testGuardedActionCall': 'oms',
    'v1.article.setVindenStockQuantity': 'oms',
    'v1.article.setBatchQuantity': 'oms',
    'v1.article.updateStockQuantities': 'oms',
    'v1.article.updateExactaStockQuantities': 'oms',
    'v1.article.updateFortnoxStockQuantities': 'oms',
    'v1.article.ensureInvariants': 'oms',
    'v1.article.blockBatch': 'oms',
    'v1.article.unblockBatch': 'oms',
    'v1.article.blockBatchesOnOrderFullfillmentCenter': 'oms',
    'v1.article.unblockBatchesOnOrderFullfillmentCenter': 'oms',
    'v1.article.blockAllBatches': 'oms',
    'v1.article.unblockAllBatches': 'oms',
    'v1.article.updateFromExternalSource': 'oms',
    'v1.article.writeArticle': 'oms',
    'v1.article.importArticle': 'oms',
    'v1.article.addFlaivyImages': 'oms',
    'v1.article.updateStockKeepingUnits': 'oms',
    'v1.article.fortnoxArticle': 'oms',
    'v1.article.editArticleBatches': 'oms',
    'v1.article.updateStockQuantitiesManually': 'oms',
    'v1.article.privabImportArticle': 'oms',
    'v1.article.ensureArticleBatchesForOfc': 'oms',
    'v1.article.addLabel': 'oms',
    'v1.article.removeLabel': 'oms',
    'v1.article.upsert': 'oms',
    'v1.article.upsertWhenEmpty': 'oms',
    'v1.article.updateWhenEmpty': 'oms',
    'v1.article.update': 'oms',
    'v1.order.changeOrigin': 'oms',
    'v1.order.placeOrder': 'oms',
    'v1.order.sendToWarehouse': 'oms',
    'v1.order.changeDeliveryDate': 'oms',
    'v1.order.startWarehouseProcessing': 'oms',
    'v1.order.setInDraftState': 'oms',
    'v1.order.setInWaitingForRestockState': 'oms',
    'v1.order.setInWaitingForAdvancePaymentState': 'oms',
    'v1.order.setEMCSInformation': 'oms',
    'v1.order.markAsReady': 'oms',
    'v1.order.setEmailSent': 'oms',
    'v1.order.shipOrder': 'oms',
    'v1.order.deliverOrder': 'oms',
    'v1.order.invoiceOrder': 'oms',
    'v1.order.cancel': 'oms',
    'v1.order.writeOrder': 'oms',
    'v1.order.writeSystembolagetOrder': 'oms',
    'v1.order.setTrackingCode': 'oms',
    'v1.order.fortnoxOrder': 'oms',
    'v1.order.deviationInDelivery': 'oms',
    'v1.order.ensureInvariants': 'oms',
    'v1.order.pushToState': 'oms',
    'v1.order.mergeOrder': 'oms',
    'v1.order.approveDropshipOrder': 'oms',
    'v1.order.shipDropshipOrder': 'oms',
    'v1.order.publicCancelOrder': 'oms',
    'v1.order.publicApproveOrder': 'oms',
    'v1.order.publicChangeOrder': 'oms',
    'v1.order.publicGetOrder': 'oms',
    'v1.order.changeOrderFullfillmentCenter': 'oms',
    'v1.order.changeOrderFullfillmentCenterTemporarySolutionForSuper': 'oms',
    'v1.order.connectSupplierCustomerToOrder': 'oms',
    'v1.order.upsertOrderWithQuantitiesPerColli': 'oms',
    'v1.order.upsert': 'oms',
    'v1.order.upsertWhenEmpty': 'oms',
    'v1.order.updateWhenEmpty': 'oms',
    'v1.order.update': 'oms',
    'v1.supplierSalesReport.setOwningSupplierOrganization': 'oms',
    'v1.supplierSalesReport.upsert': 'oms',
    'v1.supplierSalesReport.upsertWhenEmpty': 'oms',
    'v1.supplierSalesReport.updateWhenEmpty': 'oms',
    'v1.supplierSalesReport.update': 'oms',
    'v1.purchaseOrder.writeOrder': 'oms',
    'v1.purchaseOrder.placeOrder': 'oms',
    'v1.purchaseOrder.addRemark': 'oms',
    'v1.purchaseOrder.setArcNumber': 'oms',
    'v1.purchaseOrder.markAsEmcsProcessed': 'oms',
    'v1.purchaseOrder.sendToSupplier': 'oms',
    'v1.purchaseOrder.resendOrder': 'oms',
    'v1.purchaseOrder.shipOrder': 'oms',
    'v1.purchaseOrder.markAsReceived': 'oms',
    'v1.purchaseOrder.cancel': 'oms',
    'v1.purchaseOrder.removeRow': 'oms',
    'v1.purchaseOrder.removeSuggestionRows': 'oms',
    'v1.purchaseOrder.resupplyArticle': 'oms',
    'v1.purchaseOrder.changeDeliveryDate': 'oms',
    'v1.purchaseOrder.processDelivery': 'oms',
    'v1.purchaseOrder.ensureInvariants': 'oms',
    'v1.purchaseOrder.downloadEMCS': 'oms',
    'v1.purchaseOrder.upsert': 'oms',
    'v1.purchaseOrder.upsertWhenEmpty': 'oms',
    'v1.purchaseOrder.updateWhenEmpty': 'oms',
    'v1.purchaseOrder.update': 'oms',
    'v1.invoice.writeInvoice': 'oms',
    'v1.invoice.ensureInvariants': 'oms',
    'v1.invoice.upsert': 'oms',
    'v1.invoice.upsertWhenEmpty': 'oms',
    'v1.invoice.updateWhenEmpty': 'oms',
    'v1.invoice.update': 'oms',
    'v1.priceList.addArticle': 'oms',
    'v1.priceList.addCustomerSubUnit': 'oms',
    'v1.priceList.addSupplierCustomer': 'oms',
    'v1.priceList.removeSupplierCustomer': 'oms',
    'v1.priceList.moveSupplierCustomer': 'oms',
    'v1.priceList.writePriceList': 'oms',
    'v1.priceList.writePriceListForCustomer': 'oms',
    'v1.priceList.writePriceListFast': 'oms',
    'v1.priceList.deactivate': 'oms',
    'v1.priceList.activate': 'oms',
    'v1.priceList.upsert': 'oms',
    'v1.priceList.upsertWhenEmpty': 'oms',
    'v1.priceList.updateWhenEmpty': 'oms',
    'v1.priceList.update': 'oms',
    'v1.campaign.writeCampaign': 'oms',
    'v1.campaign.upsert': 'oms',
    'v1.campaign.upsertWhenEmpty': 'oms',
    'v1.campaign.updateWhenEmpty': 'oms',
    'v1.campaign.update': 'oms',
    'v1.purchaseList.writePurchaseList': 'oms',
    'v1.purchaseList.addArticleToPurchaseList': 'oms',
    'v1.purchaseList.removeArticleFromPurchaseList': 'oms',
    'v1.purchaseList.addToMyFavorites': 'oms',
    'v1.purchaseList.removeFromMyFavorites': 'oms',
    'v1.purchaseList.copy': 'oms',
    'v1.purchaseList.deactivate': 'oms',
    'v1.purchaseList.activate': 'oms',
    'v1.purchaseList.upsert': 'oms',
    'v1.purchaseList.upsertWhenEmpty': 'oms',
    'v1.purchaseList.updateWhenEmpty': 'oms',
    'v1.purchaseList.update': 'oms',
    'v1.complaint.writeComplaint': 'oms',
    'v1.complaint.beginReview': 'oms',
    'v1.complaint.comment': 'oms',
    'v1.complaint.resolveComplaint': 'oms',
    'v1.complaint.cancel': 'oms',
    'v1.complaint.ensureInvariants': 'oms',
    'v1.complaint.upsert': 'oms',
    'v1.complaint.upsertWhenEmpty': 'oms',
    'v1.complaint.updateWhenEmpty': 'oms',
    'v1.complaint.update': 'oms',
    'v1.orderFullfillmentCenter.activate': 'oms',
    'v1.orderFullfillmentCenter.deactivate': 'oms',
    'v1.orderFullfillmentCenter.writeOrderFullfillmentCenter': 'oms',
    'v1.orderFullfillmentCenter.setDeliveryRules': 'oms',
    'v1.orderFullfillmentCenter.setOrderFlowRules': 'oms',
    'v1.orderFullfillmentCenter.setDeliveryRulesOverrides': 'oms',
    'v1.orderFullfillmentCenter.upsert': 'oms',
    'v1.orderFullfillmentCenter.upsertWhenEmpty': 'oms',
    'v1.orderFullfillmentCenter.updateWhenEmpty': 'oms',
    'v1.orderFullfillmentCenter.update': 'oms',
    'v1.supplierCustomerInOmsService.upsert': 'oms',
    'v1.supplierCustomerInOmsService.upsertWhenEmpty': 'oms',
    'v1.supplierCustomerInOmsService.updateWhenEmpty': 'oms',
    'v1.supplierCustomerInOmsService.update': 'oms',
    'v1.organizationInOmsService.upsert': 'oms',
    'v1.organizationInOmsService.upsertWhenEmpty': 'oms',
    'v1.organizationInOmsService.updateWhenEmpty': 'oms',
    'v1.organizationInOmsService.update': 'oms',
    'v1.label.activate': 'oms',
    'v1.label.deactivate': 'oms',
    'v1.label.writeLabel': 'oms',
    'v1.label.upsert': 'oms',
    'v1.label.upsertWhenEmpty': 'oms',
    'v1.label.updateWhenEmpty': 'oms',
    'v1.label.update': 'oms',
    'v1.omsEventsource.cleanUpOldEvents': 'oms',
    'v1.omsEventsource.undoEvent': 'oms',
    'v1.omsEventsource.reEmit': 'oms',
};
